'use client'
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "@/components/Button";
import {hover, marengo, text, white} from "@/styles/globalStyleVars";
import {Img} from "@/components/Img";
import {toast} from "react-toastify";
import Title from "@/components/Title";
import {useForm} from "react-hook-form";
import axios from "axios";
import parser from "html-react-parser";


const StyaWithUsForm = ({title, img, link, form_id, form_tag, description, form_decription}) => {

    const [IsSubmitting, setIsSubmitting] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsSubmitting(false);
        }, 300);
    }, []);

    const {register, handleSubmit, formState, reset} = useForm({mode: "all"});
    const {errors, isSubmitSuccessful, isSubmitting} = formState;


    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    // // form submit
    const [reg, setReg] = useState({
        name: "",
        department: "",
        phone: "",
        email: "",
        msg: "",
    });


    const onSubmit = async (data) => {
        setIsSubmitting(true); // Show spinner
        try {
            const formData = new FormData();
            formData.append("_wpcf7_unit_tag", "form_" + form_tag ? form_tag : "e99210b");
            formData.append("your-name", data?.name);
            formData.append("email", data?.email);
            formData.append("phone", data?.phone);
            formData.append("location", data?.location);
            formData.append("your-message", data?.message);

            const response = await axios.post(
                `https://cms.ups-bd.com/wp-json/contact-form-7/v1/contact-forms/${form_id ? form_id : '245'}/feedback`,
                formData
            );

            if (response.status === 200) {
                success(response?.data?.message);
                reset(); // Reset form fields
            } else {
                error("Failed to submit form. Please try again later.");
            }
        } catch (err) {

            error(
                err?.message
                    ? err?.message
                    : "Failed to submit form. Please try again later."
            );
        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };

    const onError = (errors) => {

        // setToastShown(false); // Reset toast shown state on new submission attempt
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };


    return (
        (<StyledGetInTouch className="enquiry pt-120 pb-120">
            <Container>
                <Row>
                    <Col xs={12} sm={12} md={6} className='contact-from-right'>
                        <div className="contact-from-right__image">
                            <Img src={img ? img : '/images/dynamic/register-sections.webp'}/>
                            <div className="content">
                                <Title text={title ? title : ''} color={`${white}`}/>
                                <p>{description ? parser(description) : ''}</p>

                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={6} className='contact-from-left'>
                        <div className='contact-from-left__inner'>
                            <Title text={title ? title : ''} color={`${white}`}/>
                            <p>{form_decription ? parser(form_decription) : ''}</p>
                            <Form className={'form'}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Control
                                        className={
                                            formState?.errors?.name?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("name", {
                                            required: "Enter your full name",
                                            pattern: {
                                                value: /^[A-Za-z ]+$/,
                                                message: "Name must contain only letters",
                                            },
                                        })}
                                        type="text"
                                        placeholder="Name*"
                                        disabled={isSubmitting}
                                    />
                                    {errors.name && (
                                        <span className="error-message form-error">
                      {errors.name.message}
                    </span>
                                    )}
                                </Form.Group>

                                <div className="phoneEmail">
                                    <div className="form-group">
                                        <Form.Group controlId="formBasicPhone">
                                            <Form.Control
                                                className={
                                                    formState?.errors?.phone?.message
                                                        ? "has-error form-control-lg"
                                                        : "form-control-lg"
                                                }
                                                {...register("phone", {
                                                    required: {
                                                        value: true,
                                                        message: "Enter your phone number",
                                                    },
                                                    pattern: {
                                                        value: /^01[0-9]{9}$/,
                                                        message: "Enter a valid 11 digit phone number",
                                                    },
                                                })}
                                                type="number"
                                                placeholder="Phone / WhatsApp*"
                                                disabled={isSubmitting}
                                            />
                                            {errors.phone && (
                                                <span className="error-message form-error">
                        {errors.phone.message}
                      </span>
                                            )}
                                        </Form.Group>
                                    </div>
                                    <div className="form-group">
                                        <Form.Group controlId="formBasicEmail">
                                            <Form.Control
                                                className={
                                                    formState?.errors?.email?.message
                                                        ? "has-error form-control-lg"
                                                        : "form-control-lg"
                                                }
                                                {...register("email", {
                                                    required: {
                                                        value: false,
                                                        message: "Enter a valid email address",
                                                    },
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: "Enter a valid email address",
                                                    },
                                                })}
                                                type="email"
                                                placeholder="Email"
                                                disabled={isSubmitting}
                                            />
                                            {errors.email && (
                                                <span className="error-message form-error">
                        {errors.email.message}
                      </span>
                                            )}
                                        </Form.Group>
                                    </div>

                                </div>

                                <Form.Group controlId="formBasicEmail">
                                    <Form.Control
                                        className={
                                            formState?.errors?.location?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("location", {
                                            required:  {
                                                value: false,
                                                message: "Enter your Location",
                                            },
                                        })}
                                        type="text"
                                        placeholder="Location"
                                        disabled={isSubmitting}
                                    />
                                    {errors.location && (
                                        <span className="error-message form-error">
                      {errors.location.message}
                    </span>
                                    )}
                                </Form.Group>

                                <div className="form-group">
                                    <Form.Group controlId="formBasicPhone">
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            className={
                                                formState?.errors?.message?.message
                                                    ? "has-error form-control-lg"
                                                    : "form-control-lg"
                                            }
                                            {...register("message", {
                                                required: {
                                                    value: false,
                                                    message: "Enter your Message",
                                                },
                                            })}
                                            // type="textarea"
                                            placeholder="Property Details"
                                            disabled={isSubmitting}
                                        />
                                        {errors.message && (
                                            <span className={"form-error error-message"}>
                      {errors.message?.message}
                    </span>
                                        )}
                                    </Form.Group>
                                </div>
                                <div
                                    style={{width: "fit-content"}}
                                    onClick={handleSubmit(onSubmit, onError)}
                                >
                                    <Button text={'Submit'} src={"javascript:void(0)"}
                                            border={`1px`}
                                            borderColor={`${white}`}
                                            hoverBackground={`${hover}`}
                                            color={`${white}`}
                                            padding={'10px 20px'}
                                    />
                                </div>
                            </Form>
                        </div>
                    </Col>


                </Row>
            </Container>
        </StyledGetInTouch>)
    );
};


const StyledGetInTouch = styled.section`
    background: #dddbdb;

    @media(max-width: 767px){
        padding: 0;
    }
    
    h2 {
        font-weight: 800;
    }

    .contact-from-right {
        padding-right: 0;
        position: relative;
        .global-image{
            &:after{
                position: absolute;
                inset: 0;
                height: 100%;
                width: 100%;
                object-fit: cover;
                background-color: rgb(0,0,0,0.4);
                content: '';
                z-index: 1;
            }
        }
        .content {
            position: absolute;
            width: calc(100% - 100px);
            left: 0;
            right: 0;
            margin: 0 auto;
            top: 50px;
            z-index: 2;
            p {
                color: white;
            }
        }

        &__image {
            padding-top: calc(570 / 670 * 100%);
            position: relative;
            height: 100%;
        }
    }

    .contact-from-left {
        padding-left: 0;


        &__inner {
            background-color: ${marengo};
            padding: 70px 70px 107px 70px;
            height: 100%;

            p {
                color: white;
            }

            h3 {
                font-size: 40px;
                font-weight: 700;
                line-height: 46px;
                color: ${text};
                margin-bottom: 0;
            }

            form {
                margin-top: 40px;
            }

            .form-group {
                margin-bottom: 30px !important;
            }

            .form-control {
                margin-bottom: 30px !important;
                height: 50px;
                line-height: 53px;
                color: ${white};
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                border-radius: 0;
                border: none;
                border-bottom: 1px solid #D1D1D1;
                background-color: transparent;
                padding: 0;

                &::placeholder {
                    font-size: 14px;
                    color: ${white};
                    opacity: .6;
                    line-height: 20px;
                    font-weight: 500;
                    margin-bottom: 15px;
                }
            }
        }
    }

    @media (min-width: 1550px) {
        .contact-from-right {
            &__image {
                padding-top: calc(800 / 822 * 100%);
            }
        }

        .contact-from-left {
            &__inner {

                h3 {
                    font-size: 48px;
                    line-height: 56px;
                }

                .form-control {
                    font-size: 16px !important;
                }
            }
        }
    }

    @media (max-width: 1091px) {
        .contact-from-left {
            &__inner {
                padding: 40px 30px 65px 30px;
            }
        }
    }

    @media (max-width: 767px) {

        .row {
            flex-direction: column-reverse;
        }

        .contact-from-right {
            padding-left: 0;

            &__image {
                padding-top: calc(300 / 345 * 100%);
            }
            
            @media(max-width: 767px){
                .content{
                    position: relative;
                    width: calc(100% - 30px);
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    top: unset;
                    z-index: 2;
                    bottom: 30px;
                }
            }
        }

        .contact-from-left {
            padding-right: 0;

            &__inner {
                padding: 40px 15px;

                h3 {
                    font-size: 32px !important;
                    line-height: 36px;
                    margin-bottom: 40px;
                }

                .form-group {
                    margin-bottom: 30px !important;
                }

                .form-top {
                    font-size: 16px !important;
                }

                form {
                    margin-top: 40px;
                    padding-right: 0;
                }

                .dc-btn {
                    width: 100%;
                }
            }
        }
    }
`

export default StyaWithUsForm;